<template>
    <nav v-if="hasData" class="flex" aria-label="Breadcrumb">
        <ol class="flex mx-auto px-4 w-full max-w-screen-xl space-x-2 sm:px-6 sm:space-x-4 lg:px-8">
            <li v-if="root" class="flex">
                <div class="flex items-center">
                    <Link :href="root.url" class="text-gray-600 hover:text-indigo-500 text-sm sm:ml-4">{{ truncate(root.text, truncateLength) }}</Link>
                </div>
            </li>

            <li class="flex max-w-prose" v-for="crumb in crumbs">
                <div class="flex items-center">
                    <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                    </svg>
                    <Link v-if="crumb.url" :href="crumb.url" class="ml-4 text-gray-600 hover:text-indigo-500 text-sm font-medium" aria-current="page">{{ truncate(crumb.text, truncateLength) }}</Link>
                    <span v-else class="ml-4 text-gray-600 text-sm pointer-events-none" aria-current="page">{{ truncate(crumb.text, truncateLength) }}</span>
                </div>
            </li>
        </ol>
    </nav>
</template>

<script>
export default {
    name: "Breadcrumbs",

    props: {
        data: {
            default: () => [],
            type: Array,
        },
    },

    computed: {
        // Must have at least 2 crumbs else what's the point.
        hasData() {
            return this.data.length > 1
        },
        root() {
            return this.data[0]
        },
        crumbs() {
            return _.drop(this.data)
        },
    },

    data() {
        return {
            truncateLength: 30,
        }
    },
}
</script>
